export const stateCodes = {
    'ANDAMAN AND NICOBAR ISLANDS': '01',
    'ANDHRA PRADESH': '02',
    'ARUNACHAL PRADESH': '03',
    'ASSAM': '04',
    'BIHAR': '05',
    'CHANDIGARH': '06',
    'DADRA & NAGAR HAVELI AND DAMAN & DIU': '07',
    'DADRA AND NAGAR HAVELI': '07',
    'DAMAN AND DIU': '07',
    'DELHI': '09',
    'GOA': '10',
    'GUJARAT': '11',
    'HARYANA': '12',
    'HIMACHAL PRADESH': '13',
    'JAMMU & KASHMIR': '14',
    'JAMMU AND KASHMIR': '14',
    'KARNATAKA': '15',
    'KERALA': '16',
    'LAKSHWADEEP': '17',
    'LAKSHADWEEP': '17',
    'MADHYA PRADESH': '18',
    'MAHARASHTRA': '19',
    'MANIPUR': '20',
    'MEGHALAYA': '21',
    'MIZORAM': '22',
    'NAGALAND': '23',
    'ODISHA': '24',
    'PONDICHERRY': '25',
    'PUDUCHERRY': '25',
    'PUNJAB': '26',
    'RAJASTHAN': '27',
    'SIKKIM': '28',
    'TAMIL NADU': '29',
    'TRIPURA': '30',
    'UTTAR PRADESH': '31',
    'WEST BENGAL': '32',
    'CHHATTISGARH': '33',
    'UTTARAKHAND': '34',
    'JHARKHAND': '35',
    'TELANGANA': '36',
    'LADAKH': '37'
};

export const reverseStateCodes = Object.entries(stateCodes).reduce((acc, [name, code]) => {
    acc[code] = name;
    return acc;
}, {});

export const getStateCode = (stateName, defaultVal = '') => {
    if (!stateName) return defaultVal;
    const key = stateName.toUpperCase().trim();
    return stateCodes[key] || defaultVal;
};

export const formatDate = (dateString) => {
    if (!dateString) return '';
    if (typeof dateString === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        const [year, month, day] = dateString.split('-');
        return `${day}${month}${year}`;
    }
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    const dayStr = String(date.getDate()).padStart(2, '0');
    const monthStr = String(date.getMonth() + 1).padStart(2, '0');
    return `${dayStr}${monthStr}${date.getFullYear()}`;
};

export const formatAmount = (amount) => {
    const num = parseFloat(amount || 0);
    return Math.round(num).toString().padStart(15, '0');
};

export const formatDecimalAmount = (amount) => {
    const num = parseFloat(amount || 0);
    return num.toFixed(2);
};

export const padString = (str, length) => {
    return String(str || '').substring(0, length);
};

export const padNumber = (num, length) => {
    return String(num || 0).padStart(length, '0');
};

export const validateProfileCommon = (profileData, isCorrection = false) => {
    const errors = [];
    if (!profileData?.section1?.taxDeduction) errors.push('TAN of Deductor is required in Profile');
    if (!profileData?.section1?.permanentAccountNumber) errors.push('PAN of Deductor is required in Profile');
    if (!profileData?.section2?.name) errors.push('Name of Deductor is required in Profile');
    if (!profileData?.section2?.state) errors.push('State is required in Profile Section 2');
    if (!profileData?.section3?.name) errors.push('Responsible Person Name is required in Profile');
    if (!profileData?.section1?.typeOfDeduction) errors.push('Deductor Type is required in Profile');
    if (!profileData?.section3?.designation) errors.push('Responsible Person Designation is required in Profile');
    if (!profileData?.section3?.flatNo && !profileData?.section3?.nameOfPremises && !profileData?.section3?.roadStreet) {
        errors.push('Responsible Person Address is incomplete');
    }
    if (!profileData?.section3?.state) errors.push('Responsible Person State is required in Profile');
    if (!profileData?.section3?.pinCode) errors.push('Responsible Person Pincode is required in Profile');
    if (!profileData?.section3?.email) errors.push('Responsible Person Email is required in Profile');
    if (!profileData?.section3?.mobileNo) errors.push('Responsible Person Mobile is required in Profile');
    if (!profileData?.section3?.permanentAccountNumber) errors.push('Responsible Person PAN is required in Profile');
    return errors;
};

export const getTdsFormRoute = (formVal, returnType = 'Regular', financialYear = '') => {
    if (!formVal) return '/tds-dashboard/140';
    const is2026Plus = financialYear ? (parseInt(String(financialYear).split('-')[0], 10) >= 2026) : true;
    const isCorrection = returnType === 'Correction' || returnType === 'Revised';
    const suffix = isCorrection ? '-correction' : '';
    
    const f = String(formVal).toUpperCase().trim();
    let baseForm = '140';
    if (is2026Plus) {
        if (f === '138' || f === '24Q') baseForm = '138';
        else if (f === '140' || f === '26Q') baseForm = '140';
        else if (f === '143' || f === '27EQ') baseForm = '143';
        else if (f === '144' || f === '27Q') baseForm = '144';
        else baseForm = formVal.toLowerCase();
    } else {
        if (f === '138' || f === '24Q') baseForm = '24q';
        else if (f === '140' || f === '26Q') baseForm = '26q';
        else if (f === '143' || f === '27EQ') baseForm = '27eq';
        else if (f === '144' || f === '27Q') baseForm = '27q';
        else baseForm = formVal.toLowerCase();
    }

    return `/tds-dashboard/${baseForm}${suffix}`;
};
